/**
 * @file 測試服務 API
 * @description 提供測試用的 API 方法，如伺服器健康檢查等功能
 */
import { get } from './sub_services/base';
import apiPath from './api.path';
import config from 'config/config';
import ExceptionHandleService from 'utils/exceptionHandler';

const _EHS = new ExceptionHandleService({
  _NAME: 'services/test.ts',
  _NOTICE: 'test api'
});

/** [GET]punchme */
const punchme = async (params?: Record<string, unknown>): Promise<unknown> => {
  try {
    const url = `${config.SERVER_POINT}${apiPath.test.punchme}`;
    const result = await get(url, params);
    return result;
  } catch (error) {
    _EHS.errorReport(error, 'punchme', _EHS._LEVEL.ERROR);
    return Promise.reject(error);
  }
};

export default {
  punchme
};
